import { attributionHtml } from "../attribution";
import { MapSource } from "./type";

export function sourceAttributionHtml(source: MapSource): string | undefined {
  return source.attribution.length === 0
    ? undefined
    : source.attribution.map(attributionHtml).join(" | ");
}
